import { graphql } from "~/gql";

export const CREATE_MANY_TECHNOLOGY_RATES = graphql(/* GraphQL */ `
  mutation CreateManyTechnologyRates($data: CreateManyTechnologyRatesInput!) {
    createManyTechnologyRates(data: $data) {
      count
    }
  }
`);
